import React, { memo, useState, useMemo } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import  * as TYPES  from '../../models/types';
import CustomProcessSteps from '../CustomProcessSteps';
import {isMath} from '../../utils';

import styles from './styles.module.scss';

import close from '../../assets/img/public/close.svg';
import closem from '../../assets/img/public/closem.svg';
import share from '../../assets/img/public/icons/share.svg';



const Index = memo((props) => {

  const dispatch = useDispatch();
  const {basicOtherModelrEvent} = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const basicDrawerReducer = useSelector(({basicDrawerReducer}) => basicDrawerReducer);

  const [paddingTopVal, setPaddingTopVal] = useState(0);

  // 样式判断
  const normal = useMemo(() => {
    if(recReSizeReducer > 1920){
      setPaddingTopVal(0);
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      setPaddingTopVal(0);
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      setPaddingTopVal(0);
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      setPaddingTopVal(0);
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      setPaddingTopVal(200);
      return styles.normalSm;
    }
  }, [recReSizeReducer]);


  const onClose = () => {
    dispatch(basicOtherModelrEvent({
      otherVisible: TYPES.OTHERDRAWERCLOSE,
    }));
    // dispatch(basicOtherModelrClose());
    // dispatch(basicDrawerClose());
  };


  // 对选择 选择想去的目的地 进行判断展示
  const otherShowMain = () => {
    return (
      <CustomProcessSteps 
        config={
          basicDrawerReducer
        } 
        handleClone={onClose}
      />
    );
    
  }


  const modelBodyBack = () => {
    const flag = recReSizeReducer <= 750;
    return (
      <>
          {recReSizeReducer <= 750 ? <div className="rectangleTop" /> : null}
          {
            recReSizeReducer <= 750 ? null : (
              <div className="drawerHeader" style={props.config.styles}>
                <div onClick={onClose} className="close"><img src={flag ? closem : close} alt=""/></div>
                {/* <div onClick={onClose} className="share"><img src={share} alt="" /></div> */}
              </div>
            )
          }
          <div className="drawerBody" style={props.config.styles}>
            {otherShowMain()}
          </div>
      </>
    );
  }

  const modelBody = () => {
    const flag = recReSizeReducer <= 750;
    return (
      <>
          {recReSizeReducer <= 750 ? <div className="rectangleTop" /> : null}
          <div className="drawerHeader" style={props.config.styles}>
            <div onClick={onClose} className="close"><img src={flag ? closem : close} alt=""/></div>
            {/* <div onClick={onClose} className="share"><img src={share} alt="" /></div> */}
          </div>
          <div className="drawerBody" style={props.config.styles}>
            {otherShowMain()}
          </div>
      </>
    );
  }

  // 判断是：桌面/移动端
  const desktopMobile = () => {

    const drawerCss = {
      position: 'fixed',
      top: 0,
      zIndex: 1200,
      background: `rgba(0, 0, 0, 0.5)`,
      width: '100vw',
      height: '100vh',
      paddingTop: isMath(recReSizeReducer, paddingTopVal),
    }

    const { otherVisible } = basicDrawerReducer;
    return otherVisible ? (
        <div className={normal} style={drawerCss}>
          {/* {recReSizeReducer <= 750 ? <div className="rectangleTop" /> : null}
          {
            recReSizeReducer <= 750 ? null : (
              <div className="drawerHeader">
                <div onClick={onClose} className="close"><img src={close} alt=""/></div>
              </div>
            )
          }
          <div className="drawerBody">
            {otherShowMain()}
          </div> */}
          {modelBody()}
        </div>
    ) : null;
  };


  return desktopMobile();
});
export default Index;
